

export function newUid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function assetUrl(path) {
  if (!path) return path;
  if (/^https?:\/\//.test(path)) return path;
  const base = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api/v1';
  try {
    return new URL(base).origin + path;
  } catch {
    return path;
  }
}

export function formatTime(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
}

// Local midnight key (YYYY-M-D) so messages are grouped by the viewer's calendar day.
export function dayKey(d) {
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

// "Today" / "Yesterday" / a full date, for the day-divider between message groups.
export function dayLabel(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (dayKey(d) === dayKey(now)) return 'Today';
  if (dayKey(d) === dayKey(yesterday)) return 'Yesterday';
  return d.toLocaleDateString([], {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: d.getFullYear() === now.getFullYear() ? undefined : 'numeric',
  });
}

// Consecutive messages from the same author inside this window collapse into
// one visual group (avatar + header rendered once) — Discord's grouping rule.
export const GROUP_WINDOW_MS = 5 * 60 * 1000;

export const EMPTY_ARRAY = [];

export const EMPTY_OBJECT = {};
